import type { Notification } from '@shared/types/notification.types'

const now = new Date()
const hoursAgo = (h: number) => new Date(now.getTime() - h * 60 * 60 * 1000)
const daysAgo = (d: number) => new Date(now.getTime() - d * 24 * 60 * 60 * 1000)

export const mockNotifications: Notification[] = [
  {
    id: 'notif_1',
    type: 'payment',
    title: 'Payment failed',
    description: 'Payment pay_4kR9xBz for $2,450.00 failed due to insufficient funds.',
    timestamp: hoursAgo(1),
    read: false,
    priority: 'high',
    actionUrl: '/payments',
  },
  {
    id: 'notif_2',
    type: 'dispute',
    title: 'New dispute opened',
    description: 'Customer filed a dispute for $189.99 on transaction txn_8mQ2wLp.',
    timestamp: hoursAgo(2),
    read: false,
    priority: 'critical',
    actionUrl: '/disputes',
  },
  {
    id: 'notif_3',
    type: 'billing',
    title: 'Invoice overdue',
    description: 'Invoice INV-2024-0847 for Acme Corp is 7 days past due ($12,500.00).',
    timestamp: hoursAgo(4),
    read: false,
    priority: 'high',
    actionUrl: '/invoices',
  },
  {
    id: 'notif_4',
    type: 'system',
    title: 'Scheduled maintenance',
    description: 'API maintenance window scheduled for March 5, 2:00 AM - 4:00 AM UTC.',
    timestamp: hoursAgo(6),
    read: false,
    priority: 'medium',
  },
  {
    id: 'notif_5',
    type: 'payment',
    title: 'Large payment received',
    description: 'Payment of $45,000.00 received from Enterprise Solutions Ltd.',
    timestamp: hoursAgo(8),
    read: true,
    priority: 'low',
    actionUrl: '/payments',
  },
  {
    id: 'notif_6',
    type: 'compliance',
    title: 'KYC review required',
    description: 'Merchant application APP-2891 requires additional documentation review.',
    timestamp: hoursAgo(12),
    read: true,
    priority: 'medium',
    actionUrl: '/merchants',
  },
  {
    id: 'notif_7',
    type: 'dispute',
    title: 'Dispute resolved in your favor',
    description: 'Dispute for $320.00 on txn_3nP7kYs has been resolved. Funds returned.',
    timestamp: daysAgo(1),
    read: true,
    priority: 'low',
    actionUrl: '/disputes',
  },
  {
    id: 'notif_8',
    type: 'billing',
    title: 'Subscription renewed',
    description: 'Subscription sub_9wR4mHx for TechStart Inc. renewed at $299/mo.',
    timestamp: daysAgo(1),
    read: true,
    priority: 'low',
    actionUrl: '/subscriptions',
  },
  {
    id: 'notif_9',
    type: 'system',
    title: 'New API version available',
    description: 'API v2024-03 is now available with improved webhook reliability.',
    timestamp: daysAgo(2),
    read: true,
    priority: 'low',
  },
  {
    id: 'notif_10',
    type: 'payment',
    title: 'Payout completed',
    description: 'Payout of $18,742.50 has been deposited to your bank account ending in 4821.',
    timestamp: daysAgo(2),
    read: true,
    priority: 'low',
  },
  {
    id: 'notif_11',
    type: 'compliance',
    title: 'Compliance scorecard updated',
    description: 'Your Q1 compliance scorecard is now available for review.',
    timestamp: daysAgo(3),
    read: true,
    priority: 'medium',
    actionUrl: '/compliance/scorecards',
  },
  {
    id: 'notif_12',
    type: 'payment',
    title: 'High decline rate detected',
    description: 'Card decline rate for Visa transactions reached 8.2% in the last hour.',
    timestamp: daysAgo(3),
    read: true,
    priority: 'high',
    actionUrl: '/payments-channels/declines',
  },
]
